/* ============================================================
   HAREEF — Product page v2 ("MASDR layout") behaviour
   Loaded only on product templates.

   Does four things:
     1. moves the tabs section under the gallery on desktop
     2. keeps the quantity tier cards in sync with the qty input
     3. keeps the Unit Price / Total Price bar live
     4. feeds the real quantity to the COD popup
   ============================================================ */
(function () {
  'use strict';

  var SEC = '.hdt-section-main-product, [class*="hdt-section--feature-product"]';
  var DESKTOP = '(min-width: 1150px)';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- config injected by the _liquid block ----------
     <div id="hpdp-data" data-money-format="LE {{amount}}"
          data-variants="44261600886872:59900,44261600919640:59900"></div>   */
  var cfg = { moneyFormat: 'LE {{amount}}', variants: {} };
  (function readCfg() {
    var el = document.getElementById('hpdp-data');
    if (!el) return;
    cfg.moneyFormat = el.getAttribute('data-money-format') || cfg.moneyFormat;
    (el.getAttribute('data-variants') || '').split(',').forEach(function (pair) {
      var p = pair.split(':');
      if (p.length === 2) cfg.variants[p[0].trim()] = parseInt(p[1], 10);
    });
  })();

  /* ---------- money ---------- */
  function withDelims(cents, precision, thousands, decimal) {
    thousands = thousands || ','; decimal = decimal || '.';
    if (isNaN(cents) || cents == null) return '0';
    var n = (cents / 100).toFixed(precision == null ? 2 : precision).split('.');
    var head = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return head + (n[1] ? decimal + n[1] : '');
  }
  function money(cents) {
    var fmt = cfg.moneyFormat || 'LE {{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var v;
    switch (m && m[1]) {
      case 'amount_no_decimals': v = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': v = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = withDelims(cents, 0, '.', ','); break;
      default: v = withDelims(cents, 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  /* ---------- elements ---------- */
  function qtyInput() {
    // the visible stepper inside the buy-button row (NOT the sticky-bar clone)
    var all = $$('input.hdt-quantity__input[name="quantity"]').filter(function (i) {
      return !/sticky/i.test(i.id || '') && i.offsetParent !== null;
    });
    return all[0] || $('input.hdt-quantity__input[name="quantity"]');
  }
  function currentVariantId() {
    var f = $('form[action*="/cart/add"]');
    var i = f && f.querySelector('[name="id"]');
    return i ? String(i.value) : null;
  }
  function unitPriceCents() {
    var id = currentVariantId();
    if (id && cfg.variants && cfg.variants[id] != null) return cfg.variants[id];
    // fallback: first variant we know about
    var keys = Object.keys(cfg.variants || {});
    return keys.length ? cfg.variants[keys[0]] : 0;
  }
  function qty() {
    var i = qtyInput();
    var v = i ? parseInt(i.value, 10) : 1;
    return (!v || v < 1) ? 1 : v;
  }

  /* ---------- 1. tabs under the gallery (desktop only) ---------- */
  var tabsHome = null, tabsNode = null;
  function placeTabs() {
    tabsNode = tabsNode || $('[id*="__tabs"]');
    if (!tabsNode) return;
    var media = $('.hdt-product-media-wrapps');
    if (!media) return;
    if (!tabsHome) tabsHome = { parent: tabsNode.parentNode, next: tabsNode.nextSibling };

    var wide = window.matchMedia(DESKTOP).matches;
    var slot = $('.hdt-pdp-tabs-slot');

    if (wide) {
      if (!slot) {
        slot = document.createElement('div');
        slot.className = 'hdt-pdp-tabs-slot';
        media.appendChild(slot);
      }
      if (tabsNode.parentNode !== slot) slot.appendChild(tabsNode);
    } else if (tabsHome.parent && tabsNode.parentNode !== tabsHome.parent) {
      tabsHome.parent.insertBefore(tabsNode, tabsHome.next);
      if (slot) slot.remove();
    }
  }

  /* ---------- 2 + 3. tiers and the live summary bar ---------- */
  function setQty(n) {
    var i = qtyInput();
    if (!i) return;
    i.value = n;
    i.dispatchEvent(new Event('input', { bubbles: true }));
    i.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* The discount is a THRESHOLD, not an exact match: "2 pieces, 10% off"
     means 10% off at 2 or more. That's how the Shopify automatic discount
     and the COD backend both apply it, so the display has to agree —
     otherwise someone buying 3 would be shown full price and charged less. */
  function activeTier(n) {
    var best = null, bestQty = 0;
    $$('.hpdp-tier').forEach(function (card) {
      var tq = parseInt(card.getAttribute('data-qty'), 10) || 1;
      if (tq <= n && tq >= bestQty) { best = card; bestQty = tq; }
    });
    return best;
  }

  function paint() {
    var unit = unitPriceCents();
    var n = qty();
    var active = activeTier(n);

    // tier cards: price per tier + active state
    $$('.hpdp-tier').forEach(function (card) {
      var tq = parseInt(card.getAttribute('data-qty'), 10) || 1;
      var off = parseFloat(card.getAttribute('data-discount')) || 0; // percent
      var each = Math.round(unit * (1 - off / 100));
      var pe = card.querySelector('.hpdp-tier-price');
      var pt = card.querySelector('.hpdp-tier-total');
      if (pe) pe.textContent = money(each);
      if (pt) pt.textContent = '= ' + money(each * tq);
      var on = (card === active);
      card.classList.toggle('is-active', on);
      var r = card.querySelector('input[type="radio"]');
      if (r) r.checked = on;
    });

    // summary bar — unit price reflects the saving the buyer actually gets
    var off2 = active ? (parseFloat(active.getAttribute('data-discount')) || 0) : 0;
    var eachNow = Math.round(unit * (1 - off2 / 100));
    var u = $('[data-hpdp-unit]');
    var t = $('[data-hpdp-total]');
    if (u) u.textContent = money(eachNow);
    if (t) t.textContent = money(eachNow * n);
    lastTotalCents = eachNow * n;
  }

  /* ---------- 4. hand the real numbers to the COD popup ----------
     The popup has to tell InstaPay/Vodafone buyers exactly what to transfer, and
     that figure includes shipping. Parsing it back out of the formatted string
     would break on any money format, so hand over the raw cents instead. */
  var lastTotalCents = 0;
  function exposeQty() {
    window.hareefPdpQty = qty;
    window.hareefPdpTotalCents = function () { return lastTotalCents; };
    window.hareefMoney = money;
  }

  /* ---------- wiring ---------- */
  function onReady() {
    if (!$(SEC) && !$('form[action*="/cart/add"]')) return;

    placeTabs();
    paint();
    exposeQty();

    // tier card clicks
    document.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('.hpdp-tier');
      if (!card) return;
      e.preventDefault();
      setQty(parseInt(card.getAttribute('data-qty'), 10) || 1);
      paint();
    });

    // anything that can change variant or quantity
    ['change', 'input'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        if (!e.target.closest) return;
        if (e.target.closest('form[action*="/cart/add"], .hdt-variant-picker, .hdt-quantity-wrapp')) {
          setTimeout(paint, 30);
        }
      }, true);
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.hdt-quantity__button')) setTimeout(paint, 30);
    });

    // Kalles re-renders the price node on variant change — follow it
    var priceNode = $('.hdt-product__price');
    if (priceNode && window.MutationObserver) {
      new MutationObserver(function () { setTimeout(paint, 20); })
        .observe(priceNode, { childList: true, subtree: true, characterData: true });
    }

    window.addEventListener('resize', debounce(placeTabs, 180));
    document.addEventListener('shopify:section:load', function () {
      tabsHome = null; tabsNode = null;
      setTimeout(function () { placeTabs(); paint(); }, 60);
    });
  }

  function debounce(fn, ms) {
    var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
